import { AgreementStatus, ConnectResult, Data, createPromiseClient } from '@/connect';
import { AgreementService } from '@/connect/gen/modules/apiengine/services/agreements/agreements_pb';
import {
  ApproveAgreementRequest,
  ApproveAgreementResponse,
  CancelAgreementRequest,
  CancelAgreementResponse,
  CreateAgreementRequest,
  CreateAgreementResponse,
  ListAgreementsRequest,
  ListAgreementsResponse,
  ModifyAgreementRequest,
  ModifyAgreementResponse,
  RejectAgreementRequest,
  RejectAgreementResponse,
} from '@/connect/gen/modules/apiengine/services/agreements/agreements_pb';

export * from '@/connect/gen/modules/apiengine/services/agreements/agreements_pb';

export const agreementsService = new (class {
  public readonly promiseClient = createPromiseClient(AgreementService);

  public async createAgreement(
    config: Data<CreateAgreementRequest>
  ): Promise<ConnectResult<CreateAgreementResponse>> {
    const result = await this.promiseClient.createAgreement(config);
    return result as ConnectResult<CreateAgreementResponse>;
  }

  public async approveAgreement(
    config: Data<ApproveAgreementRequest>
  ): Promise<ConnectResult<ApproveAgreementResponse>> {
    const result = await this.promiseClient.approveAgreement(config);
    return result as ConnectResult<ApproveAgreementResponse>;
  }

  public async rejectAgreement(
    config: Data<RejectAgreementRequest>
  ): Promise<ConnectResult<RejectAgreementResponse>> {
    const result = await this.promiseClient.rejectAgreement(config);
    return result as ConnectResult<RejectAgreementResponse>;
  }

  public async modifyAgreement(
    config: Data<ModifyAgreementRequest>
  ): Promise<ConnectResult<ModifyAgreementResponse>> {
    const result = await this.promiseClient.modifyAgreement(config);
    return result as ConnectResult<ModifyAgreementResponse>;
  }

  public async cancelAgreement(
    config: Data<CancelAgreementRequest>
  ): Promise<ConnectResult<CancelAgreementResponse>> {
    const result = await this.promiseClient.cancelAgreement(config);
    return result as ConnectResult<CancelAgreementResponse>;
  }

  public async queryAgreements(
    config: Data<ListAgreementsRequest>,
    asCompanyId?: string // brokers can view-as-company
  ): Promise<ConnectResult<ListAgreementsResponse>> {
    const query = {
      statuses: config.statuses?.length
        ? config.statuses
        : [
            AgreementStatus.ACTIVE,
            AgreementStatus.CANCELED,
            AgreementStatus.DRAFT,
            AgreementStatus.INACTIVE,
            AgreementStatus.REJECTED,
            AgreementStatus.AGREEMENT_STATUS_UNSPECIFIED,
          ],
      side: config.side,
      eligibleInstrument: config.eligibleInstrument,
    };
    const result = await this.promiseClient.listAgreements(query, {
      ...(asCompanyId && { headers: { 'As-Company': asCompanyId } }),
    });
    return result as ConnectResult<ListAgreementsResponse>;
  }
})();
